export const LINK_DESTINATION_CODE_REQUEST = "LINK_DESTINATION_CODE_REQUEST";
export const LINK_DESTINATION_CODE_SUCCESS = "LINK_DESTINATION_CODE_SUCCESS";
export const LINK_DESTINATION_CODE_ERROR = "LINK_DESTINATION_CODE_ERROR";
